import { defineStore } from 'pinia';
import axios from '../bootstrap';  // Use our configured axios instance
import router from '@/router';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        authenticated: false,
        authenticationResponseMessage: null,
        loggedOutMessage: null,
        processing: null,
        user: {
            id: null
        },
        tokenRefreshTimer: null,
    }),
    getters: {
        // canViewAdmin() {
        //     if(this.user.permissions) {
        //         return this.user.permissions.indexOf('view-admin') >= 0
        //     } else {
        //         return false
        //     }
        // },
    },
    actions: {
        // Refresh CSRF token - utility method
        async refresh_csrf_token() {
            try {
                await axios.get('/sanctum/csrf-cookie');
                console.log('CSRF token refreshed successfully');
                return true;
            } catch (error) {
                console.error('Failed to refresh CSRF token:', error);
                return false;
            }
        },

        // Start periodic token refresh (useful for long-running app sessions)
        start_token_refresh_timer(intervalMinutes = 30) {
            // Clear any existing timer
            this.stop_token_refresh_timer();
            
            const intervalMs = intervalMinutes * 60 * 1000;
            console.log(`Starting CSRF token refresh timer: every ${intervalMinutes} minutes`);
            
            this.tokenRefreshTimer = setInterval(async () => {
                if (this.authenticated) {
                    console.log('Performing periodic CSRF token refresh');
                    const success = await this.refresh_csrf_token();
                    
                    if (!success) {
                        console.warn('Periodic token refresh failed - stopping timer');
                        this.stop_token_refresh_timer();
                    }
                } else {
                    console.log('User not authenticated - stopping token refresh timer');
                    this.stop_token_refresh_timer();
                }
            }, intervalMs);
        },

        // Stop the periodic token refresh
        stop_token_refresh_timer() {
            if (this.tokenRefreshTimer) {
                clearInterval(this.tokenRefreshTimer);
                this.tokenRefreshTimer = null;
            }
        },

        // Handle session expired events from axios interceptor
        handle_session_expired() {
            this.authenticated = false;
            this.user = { id: null };
            this.stop_token_refresh_timer();
            this.loggedOutMessage = "Your session has expired. Please log in again.";
            router.push({name: "Login"});
        },

        // Initialize auth store (call this when the app starts)
        init() {
            // Listen for session expired events from axios interceptor
            window.addEventListener('auth:session-expired', () => {
                this.handle_session_expired();
            });

            // Listen for app visibility changes to refresh tokens when app becomes active
            // This is especially useful for mobile apps that go to background
            document.addEventListener('visibilitychange', () => {
                if (!document.hidden && this.authenticated) {
                    console.log('App became visible - refreshing CSRF token');
                    this.refresh_csrf_token();
                }
            });

            // Listen for page unload to clean up timers
            window.addEventListener('beforeunload', () => {
                this.cleanup();
            });
        },

        // Cleanup method to prevent memory leaks
        cleanup() {
            this.stop_token_refresh_timer();
            console.log('Auth store cleaned up');
        },

        // query for session status and update store
        async validate_session(redirect_to_login_if_not_authenticated = true){
            const self = this
            this.processing = true

            // // temp
            // return true

            try {
                await this.refresh_csrf_token();
                return axios.get('/api/user').then(({data})=>{
                    self.user = data.user
                    self.authenticated = true
                    // Start periodic token refresh when authenticated
                    self.start_token_refresh_timer();
                }).catch( (error) => {
                    self.user = {
                        id: null
                    }
                    self.authenticated = false

                    if(redirect_to_login_if_not_authenticated) {
                        this.loggedOutMessage = "You have been logged out."
                        router.push({name: "Login"})
                    }
                });
            } catch (error) {
                console.error('Session validation failed:', error);
                self.user = {
                    id: null
                }
                self.authenticated = false

                if(redirect_to_login_if_not_authenticated) {
                    this.loggedOutMessage = "Session expired. Please log in again."
                    router.push({name: "Login"})
                }
            } finally {
                this.processing = false
            }
        },
        async login(){
            // const self = this
            // const cartStore = useCartStore()
            // const orderStore = useOrderStore()
            // const wizardStore = useWizardStore()
            // const { fetch_config_data } = getChannelConfigData();
            // const { fetch_orders_and_subs } = getOrdersAndSubs()
            // const { maybe_pull_promo_from_user_session } = promoCodeActions()
            // const { fetch_menu } = getMenu()
            // self.processing = true
            //
            // await axios.get('/sanctum/csrf-cookie')
            // await axios.get('/api/user').then(({data})=>{
            //     self.user = data.user
            //     self.session = data.session
            //     self.permissions = data.user.permissions
            //     self.authenticated = true
            //     self.session = data.session
            //     maybe_pull_promo_from_user_session()
            //
            //     fetch_config_data().then( async () => {
            //         fetch_orders_and_subs(true,true).then( async () => {
            //             console.log('in Auth / login and going to run prepopulate_cart_from_auth');
            //             const prepopulate = cartStore.prepopulate_cart_from_auth()
            //             await fetch_menu()
            //
            //             console.log('orderStore.has_ordered_or_picked_this_week_hero_product after menu fetch', orderStore.has_ordered_or_picked_this_week_hero_product)
            //
            //             if((orderStore.is_working_subscription_set && orderStore.working_subscription.picking_status_current_week === 'pick') || (!orderStore.is_working_subscription_set && orderStore.has_ordered_previously && !orderStore.has_ordered_or_picked_this_week_hero_product))  {
            //                 console.log('in Auth / login and going to run try to send them to picker page to pick meals');
            //                 console.log('orderStore.has_ordered_or_picked_this_week_hero_product', orderStore.has_ordered_or_picked_this_week_hero_product)
            //                 wizardStore.step = 2
            //                 if(orderStore.working_subscription.product_url){
            //                     this.$router.push(orderStore.working_subscription.product_url)
            //                 } else {
            //                     this.$router.push(wizardStore.channel_config.hero_product.product_url)
            //                 }
            //             }
            //             else if(orderStore.is_working_subscription_set || orderStore.has_ordered_or_picked_this_week_cart_product_id || orderStore.has_ordered_or_picked_this_week_hero_product) {
            //                 this.$router.push({name: "myAccount"})
            //             }
            //             else {
            //                 this.$router.push(wizardStore.channel_config.hero_product.product_url)
            //             }
            //         })
            //     })
            //
            //     return true
            // }).catch( (error) => {
            //     self.user = {}
            //     self.permissions = []
            //     self.authenticated = false
            // }).finally(() => {
            //     self.processing = false
            // })

        },
        async logout(){
            try {
                // Stop the token refresh timer
                this.stop_token_refresh_timer();
                
                // Clear auth state first
                this.authenticated = false;
                this.user = { id: null };
                
                // Attempt to logout on server
                await axios.post('/api/logout');
                
                this.loggedOutMessage = "You have been logged out successfully.";
            } catch (error) {
                console.error('Logout error:', error);
                this.loggedOutMessage = "Logged out (with errors).";
            } finally {
                // Always redirect to login regardless of server response
                router.push({name: "Login"});
            }
        }
    },
    persist: true,
})
